import { useLelyAuth } from '@/auth/useLelyAuth';
import List, { ListItem } from '@/common/components/List/List';
import { lelyTokenPrimitives } from '@/common/styles/newStyles/LelyMuiTheme';
import { Avatar, Box, Typography } from '@mui/material';

const t = lelyTokenPrimitives as Record<string, string>;

const UserInfo = () => {
  const { user } = useLelyAuth();
  const initials = user?.given_name?.charAt(0) + user?.family_name?.charAt(0);
  const emailPrefix = user?.email?.slice(0, 2).toUpperCase();
  const fullName =
    user?.given_name && user?.family_name
      ? `${user.given_name} ${user.family_name}`
      : undefined;
  const company = user?.company;

  const userInfoItems: ListItem[] = [
    { primary: 'Role', secondary: user?.job_title || '' },
    { primary: 'Company', secondary: company },
  ];

  return (
    <Box alignSelf="stretch">
      <Box
        display="flex"
        px={t.spaceMd}
        pt={t.space2xl}
        pb={t.spaceXl}
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={t.spaceSm}
      >
        <Avatar
          sx={{
            width: t.space8xl,
            height: t.space8xl,
            backgroundColor: t.backgroundColorBrandPrimary,
          }}
        >
          {initials || emailPrefix}
        </Avatar>
        <Box display="flex" flexDirection="column" alignItems="center">
          {fullName && (
            <Typography variant="body2" textAlign="center" color="text.primary">
              {fullName}
            </Typography>
          )}
          <Typography variant="body2" textAlign="center" color="text.secondary">
            {user?.email}
          </Typography>
        </Box>
      </Box>

      <List type="static" disablePadding items={userInfoItems} />
    </Box>
  );
};

export default UserInfo;
